
import * as React from "react"

const MOBILE_BREAKPOINT = 768

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(undefined)

  React.useEffect(() => {
    try {
      const handleResize = () => {
        try {
          const width = window.innerWidth;
          console.log("useIsMobile - Window width:", width);
          setIsMobile(width < MOBILE_BREAKPOINT);
        } catch (error) {
          console.error("Error in handleResize:", error);
          setIsMobile(false); // fallback to desktop
        }
      }
      
      // Initial check
      console.log("useIsMobile - Initial setup");
      handleResize();
      
      window.addEventListener('resize', handleResize);
      return () => {
        console.log("useIsMobile - Cleanup");
        window.removeEventListener('resize', handleResize);
      }
    } catch (error) {
      console.error("Error in useIsMobile effect:", error);
      setIsMobile(false); // fallback to desktop
    }
  }, [])

  console.log("useIsMobile - Current value:", isMobile);
  return !!isMobile
}
